import {
  IHoaDonDieuChinhThuCong,
  IHoaDonDieuChinhThuCongHuyRequest,
  IHoaDonDieuChinhThuCongSaveRequest,
  IHoaDonDieuChinhThuCongSelectRequest,
  IHoaDonDieuChinhThuCongTarget,
} from "../../../model/respone/hoa-don-dien-tu/IHoaDonDieuChinhThuCong";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHoaDonDieuChinhThuCongActionsObj = {
  SHOW_MODAL: {} as IHoaDonDieuChinhThuCongTarget,
  CLOSE_MODAL: undefined,

  LOAD_START: {} as IHoaDonDieuChinhThuCongSelectRequest,
  LOAD_SUCCESS: [] as IHoaDonDieuChinhThuCong[],
  LOAD_ERROR: "",

  SAVE_START: {} as IHoaDonDieuChinhThuCongSaveRequest,
  SAVE_SUCCESS: [] as IHoaDonDieuChinhThuCong[],
  SAVE_ERROR: "",

  HUY_START: {} as IHoaDonDieuChinhThuCongHuyRequest,
  HUY_SUCCESS: [] as IHoaDonDieuChinhThuCong[],
  HUY_ERROR: "",
};

export const eHoaDonDieuChinhThuCongActionIds = generateActionTypeIds(
  eHoaDonDieuChinhThuCongActionsObj,
  "HOA_DON_DIEU_CHINH_THU_CONG",
);

export type IHoaDonDieuChinhThuCongActionTypes = IGenericActionType<
  typeof eHoaDonDieuChinhThuCongActionsObj,
  "HOA_DON_DIEU_CHINH_THU_CONG"
>;
